import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, Input } from '@angular/core';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, DialogState } from '@skylab-angular-shared/ui';

export interface NumberingChangeUnavailableDialogInputData {
    isPreviousNumberingManual: boolean;
}

@Component({
    selector: 'numbering-change-unavailable-dialog.component',
    templateUrl: './numbering-change-unavailable-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, ButtonComponent, TranslatePipe]
})
export class NumberingChangeUnavailableDialogComponent {
    @Input() public data!: NumberingChangeUnavailableDialogInputData;

    public constructor(
        private readonly dialogService: DialogInsService,
        @Inject(L10n) private readonly l10n: L10nBase
    ) {}

    public confirm(): void {
        this.dialogService.close({ state: DialogState.Confirm });
    }

    public get message(): string {
        const type = this.data.isPreviousNumberingManual ? 'scenes.shared.numbering-change-guard.dialog.message.manual-to-auto' : 'scenes.shared.numbering-change-guard.dialog.message.auto-to-manual';
        return this.l10n._T('scenes.shared.numbering-change-guard.dialog.message.base', { type: this.l10n._T(type) });
    }
}
